import React from "react";
import { Title, Space, Text } from "@mantine/core";
import logo from "./assets/logo-icon.png";
import "./loader.style.scss"
import { useTranslation } from "react-i18next";
const LoaderComponent = ({ loading, overlayLoading }: { loading: boolean, overlayLoading: boolean }) => {
  const { t } = useTranslation();
  return (
    <div
      role="status"
      aria-live="polite"
      aria-label={t("accessibility.loading")}
      className={
        overlayLoading
          ? "loader_container transparent-loader"
          : "loader_container"
      }
    >
      <img
        alt={t("loader.alt")}
        className="rotate-Icon"
        src={logo}
        draggable="false"
        height={100}
      />
      {!overlayLoading ? (
        <>
          <Space h={50}></Space>
          <Title>{t("loader.brand")}</Title>
          <Text>{t("loader.loading")}</Text>
        </>
      ) : null}
    </div>
  );
};

export default LoaderComponent;
